import { Injectable } from '@angular/core'
import { LocaleService } from 'framework/locale/services/locale.service'

@Injectable({
    providedIn: 'root',
})
export class HomeUrlService {
    constructor(private localeService: LocaleService) {}

    getHomeUrl(): string {
        if (typeof window !== 'undefined') {
            const originUrl = window.location.origin

            if (window.location.pathname.match(/^\/\w{2}\//)) {
                const currentLanguage = this.localeService.language
                return `${originUrl}/${currentLanguage}`
            } else {
                return originUrl
            }
        }

        return '/'
    }
}
